/**
 * Bridge the platform's formatting system (numeral.js / dayjs aliases)
 * into ECharts options. Serialized JSX configs cannot contain functions,
 * so this injects real formatter callbacks at render time.
 */

function applyAxisFormatter (axis, formatAlias, formatter) {
  if (!axis) return axis
  const applyOne = (ax) => ({
    ...ax,
    axisLabel: {
      ...(ax.axisLabel || {}),
      formatter: (val) => formatter(val, formatAlias)
    }
  })
  return Array.isArray(axis) ? axis.map(applyOne) : applyOne(axis)
}

export function applyFormatters (opts, format, formatter) {
  if (!format || !formatter) return opts
  const result = { ...opts }

  if (format.xAxis && result.xAxis) {
    result.xAxis = applyAxisFormatter(result.xAxis, format.xAxis, formatter)
  }

  if (format.yAxis && result.yAxis) {
    result.yAxis = applyAxisFormatter(result.yAxis, format.yAxis, formatter)
  }

  if (format.values && result.tooltip) {
    const valFmt = (val) => formatter(val, format.values)
    result.tooltip = { ...result.tooltip }
    if (!result.tooltip.formatter || typeof result.tooltip.formatter === 'string') {
      result.tooltip.valueFormatter = valFmt
    }
  }

  return result
}
